import React, { useState } from 'react';
import { Headphones, Play, Clock } from 'lucide-react';
import MeditationPlayer from '../../MeditationPlayer';

/**
 * Chat card for a Nikki-generated guided meditation. Tapping Play opens the
 * full-screen MeditationPlayer, which generates + streams the spoken audio.
 */
const MeditationCard = ({ data }) => {
  const [open, setOpen] = useState(false);
  const { title = 'Meditation', subtitle = '', est_min, script } = data || {};

  return (
    <>
      <div
        className="rounded-sm border border-cyan-500/25 bg-gradient-to-br from-cyan-500/10 to-zinc-900/40 p-4 max-w-sm"
        data-testid="meditation-card"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-cyan-500/15 border border-cyan-400/30 flex items-center justify-center flex-shrink-0">
            <Headphones className="w-5 h-5 text-cyan-300" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[10px] text-cyan-300/70 uppercase tracking-wider">Guided meditation</p>
            <h4 className="font-secondary font-bold text-white text-base leading-tight mt-0.5" data-testid="meditation-card-title">
              {title}
            </h4>
            {subtitle && <p className="text-xs text-zinc-400 mt-0.5">{subtitle}</p>}
            {est_min ? (
              <p className="flex items-center gap-1 text-[11px] text-zinc-500 mt-1.5">
                <Clock className="w-3 h-3" /> ~{est_min} min · calm voice
              </p>
            ) : null}
          </div>
        </div>
        <button
          onClick={() => setOpen(true)}
          className="mt-3 w-full flex items-center justify-center gap-2 bg-cyan-400 text-black text-xs font-bold uppercase tracking-wider rounded-sm py-2.5 hover:bg-cyan-300 transition-colors"
          data-testid="meditation-card-play"
        >
          <Play className="w-4 h-4" /> Play meditation
        </button>
      </div>

      {open && (
        <MeditationPlayer
          script={script}
          title={title}
          subtitle={subtitle}
          estMin={est_min}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default MeditationCard;
